import { SignUpIncentiveState } from "./types";

export const initialState: SignUpIncentiveState = {
	isRewardsPopupClosed: undefined
};
